import React, { use, useEffect, useState } from "react";
import HeaderDashboard from "../../components/HeaderDashboard";
import { useUser } from "../../../contexts/UserContext";
import { useNavigate } from 'react-router-dom';
import PersonIcon from '@mui/icons-material/Person';
import { Button, TextField } from "@mui/material";
import ContactMailIcon from '@mui/icons-material/ContactMail';
import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism';
import ApartmentIcon from '@mui/icons-material/Apartment';
import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';
import Loading from "../../components/Loading";
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Chip from '@mui/material/Chip';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import axios from "axios";
import { FormatarData } from "../../../utils/FormatarData";
import { MascaraCpf } from "../../../utils/MascaraCpf";
import { MascaraCnpj } from "../../../utils/MascaraCnpj";
import { MascaraTelefone } from "../../../utils/MascaraTelefone";
import { MascaraCep } from "../../../utils/MascaraCep";
import { TirarMascara } from "../../../utils/TirarMascara";

import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import HomeIcon from '@mui/icons-material/Home';
import ArticleIcon from '@mui/icons-material/Article';
import { MascaraTituloEleitor } from "../../../utils/MascaraTituloEleitor";
import { MascaraCnh } from "../../../utils/MascaraCnh";
import AlertSuccess from "../../components/AlertSuccess";

const estadosBrasil = [
    "Acre",
    "Alagoas",
    "Amazonas",
    "Bahia",
    "Ceará",
    "Distrito Federal",
    "Espírito Santo",
    "Goiás",
    "Maranhão",
    "Mato Grosso",
    "Mato Grosso do Sul",
    "Minas Gerais",
    "Pará",
    "Paraíba",
    "Paraná",
    "Pernambuco",
    "Piauí",
    "Rio de Janeiro",
    "Rio Grande do Norte",
    "Rio Grande do Sul",
    "Rondônia",
    "Roraima",
    "Santa Catarina",
    "São Paulo",
    "Sergipe",
    "Tocantins"
];

const FichaCadastral = () => {

    const { user } = useUser();
    const navigate = useNavigate();

    const [userActive, setUserActive] = useState(true);
    const [openModalNotificacao, setOpenModalNotificacao] = useState(false);
    const [progress, setProgress] = useState(0);
    const [open, setOpen] = useState(false);
    const [regimeBens, setRegimeBens] = useState("");

    const [cpf, setCpf] = useState("");
    const [email, setEmail] = useState("");
    const [endereco, setEndereco] = useState("");
    const [nome, setNome] = useState("");
    const [telefone, setTelefone] = useState("");
    const [cep, setCep] = useState("");
    const [numero, setNumero] = useState("");
    const [complemento, setComplemento] = useState("");
    const [bairro, setBairro] = useState("");
    const [cidade, setCidade] = useState("");
    const [estado, setEstado] = useState("");
    const [estadoCivil, setEstadoCivil] = useState("");
    const [rg, setRg] = useState("");
    const [dataNascimento, setDataNascimento] = useState("");
    const [orgaoEmissor, setOrgaoEmissor] = useState("");
    const [tituloEleitor, setTituloEleitor] = useState("");
    const [pisNisNit, setPisNisNit] = useState("");
    const [cnh, setCnh] = useState("");
    const [estadoEmissaoCnh, setEstadoEmissaoCnh] = useState("");
    const [cpfConjuge, setCpfConjuge] = useState("");
    const [cnpj, setCnpj] = useState("");
    const [senhaGovBr, setSenhaGovBr] = useState("");
    const [enderecoFiscal, setEnderecoFiscal] = useState("");
    const [razaoSocial, setRazaoSocial] = useState("");
    const [nomeFantasia, setNomeFantasia] = useState("");
    const [naturalidade, setNaturalidade] = useState("");

    const [sectionOneCompleted, setSectionOneCompleted] = useState(0);
    const [sectionTwoCompleted, setSectionTwoCompleted] = useState(0);
    const [sectionThreeCompleted, setSectionThreeCompleted] = useState(0);
    const [sectionFourCompleted, setSectionFourCompleted] = useState(0);

    const [openSnackbarSuccess, setOpenSnackbarSuccess] = useState(false);
    const [mensagem, setMensagem] = useState("");

    useEffect(() => {
        setOpen(true)

        const getFicha = async () => {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/obterFichaCadastral`, {
                headers: {
                    Authorization: localStorage.getItem("token")
                }
            });

            if (response.data.status === 200) {
                setDataNascimento(response.data.ficha.dataNascimento || "");
                setRg(response.data.ficha.rg || "");
                setOrgaoEmissor(response.data.ficha.orgaoRg || "");
                setTituloEleitor(response.data.ficha.tituloEleitor || "");
                setPisNisNit(response.data.ficha.pisNisNit || "");
                setCnh(response.data.ficha.cnh || "");
                setEstadoEmissaoCnh(response.data.ficha.estadoEmissaoCnh || "");
                setNaturalidade(response.data.ficha.naturalidade || "");
                setEstadoCivil(response.data.ficha.estadoCivil || "");
                setRegimeBens(response.data.ficha.regimeBens || "");
                setCpfConjuge(response.data.ficha.cpfConjugue || "");
                setCnpj(response.data.ficha.cnpj || "");
                setSenhaGovBr(response.data.ficha.senhaGov || "");
                setEnderecoFiscal(response.data.ficha.enderecoFiscal || "");
                setRazaoSocial(response.data.ficha.razaoSocial || "");
                setNomeFantasia(response.data.ficha.nomeFantasia || "");
            }

            setEndereco(user?.endereco?.Endereco);
            setNome(user?.usuario?.Nome);
            setCpf(user?.usuario?.Cpf);
            setEmail(user?.usuario?.Email);
            setTelefone(user?.usuario?.Telefone);
            setCep(user?.endereco?.Cep);
            setNumero(user?.endereco?.Numero);
            setComplemento(user?.endereco?.Complemento);
            setBairro(user?.endereco?.Bairro);
            setCidade(user?.endereco?.Cidade);
            setEstado(user?.endereco?.Estado);

            console.log("response ficha cadastral:", response.data);
        }
        getFicha();

        setOpen(false);

    }, [user]);

    // useEffect(() => {
    //     const getFicha = async () => {
    //         const response = await axios.get(`${process.env.REACT_APP_API_URL}/obterFichaCadastral`, {
    //             headers: {
    //                 Authorization: localStorage.getItem("token")
    //             }
    //         });

    //         if (response.data.status === 200) {
    //             setDataNascimento(response.data.ficha.dataNascimento || "");
    //             setRg(response.data.ficha.rg || "");
    //             setOrgaoEmissor(response.data.ficha.orgaoRg || "");
    //             setTituloEleitor(response.data.ficha.tituloEleitor || "");
    //             setPisNisNit(response.data.ficha.pisNisNit || "");
    //             setCnh(response.data.ficha.cnh || "");
    //             setEstadoEmissaoCnh(response.data.ficha.estadoEmissaoCnh || "");
    //             setNaturalidade(response.data.ficha.naturalidade || "");
    //             setEstadoCivil(response.data.ficha.estadoCivil || "");
    //             setRegimeBens(response.data.ficha.regimeBens || "");
    //             setCpfConjuge(response.data.ficha.cpfConjugue || "");
    //             setCnpj(response.data.ficha.cnpj || "");
    //             setSenhaGovBr(response.data.ficha.senhaGov || "");
    //             setEnderecoFiscal(response.data.ficha.enderecoFiscal || "");
    //             setRazaoSocial(response.data.ficha.razaoSocial || "");
    //             setNomeFantasia(response.data.ficha.nomeFantasia || "");
    //         }

    //         console.log("response ficha cadastral:", response.data);
    //     }
    //     getFicha();
    // }, []);

    useEffect(() => {
        // Logic to check if section two is completed
        if (email && telefone && cep && endereco && numero && bairro && cidade && estado) {
            setSectionTwoCompleted(25);
        } else {
            setSectionTwoCompleted(0);
        }

        if (nome && cpf && dataNascimento && rg && orgaoEmissor && tituloEleitor && pisNisNit && naturalidade) {
            setSectionOneCompleted(25);
        } else {
            setSectionOneCompleted(0);
        }

        if (estadoCivil) {
            if (estadoCivil === "Casado(a)") {
                if (regimeBens) {
                    setSectionThreeCompleted(25);
                } else {
                    setSectionThreeCompleted(0);
                }
            } else {
                setSectionThreeCompleted(25);
            }
        } else {
            setSectionThreeCompleted(0);
        }

        if (senhaGovBr && razaoSocial && nomeFantasia) {
            setSectionFourCompleted(25);
        } else {
            setSectionFourCompleted(0);
        }
    }, [email, telefone, cep, endereco, numero, bairro, cidade, estado, nome, cpf, dataNascimento, rg, orgaoEmissor, tituloEleitor, pisNisNit, cnh, estadoEmissaoCnh, naturalidade, estadoCivil, regimeBens, cpfConjuge, cnpj, senhaGovBr, razaoSocial, nomeFantasia]);


    useEffect(() => {
        setProgress(sectionOneCompleted + sectionTwoCompleted + sectionThreeCompleted + sectionFourCompleted);
    }, [sectionOneCompleted, sectionTwoCompleted, sectionThreeCompleted, sectionFourCompleted]);


    const handleSaveFichaCadastral = async () => {
        setOpen(true);
        try {
            await axios.post(`${process.env.REACT_APP_API_URL}/atualizarFichaCadastral`, {
                dataNascimento: TirarMascara(dataNascimento),
                rg: TirarMascara(rg),
                orgaoRg: orgaoEmissor,
                tituloEleitor: TirarMascara(tituloEleitor),
                pisNisNit: TirarMascara(pisNisNit),
                cnh: TirarMascara(cnh),
                estadoEmissaoCnh,
                naturalidade,
                cep: TirarMascara(cep),
                endereco,
                numero,
                bairro,
                cidade,
                estado,
                complemento,
                estadoCivil,
                regimeBens,
                cpfConjugue: TirarMascara(cpfConjuge).slice(0, 11),
                cnpj: TirarMascara(cnpj).slice(0, 14),
                senhaGov: senhaGovBr,
                enderecoFiscal,
                razaoSocial,
                progress,
                nomeFantasia
            }, {
                headers: {
                    Authorization: localStorage.getItem("token")
                }
            });

            setMensagem("Ficha cadastral salva com sucesso!");
            setOpenSnackbarSuccess(true);
        } catch (error) {
            console.error("Error saving ficha cadastral:", error);
        } finally {
            setOpen(false);
        }
    }


    console.log("User data:", user);

    function LinearProgressWithLabel(props) {
        return (
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Box sx={{ width: '100%', mr: 1 }}>
                    <LinearProgress variant="determinate" {...props} color="success" />
                </Box>
                <Box sx={{ minWidth: 35 }}>
                    <Typography variant="body1" sx={{ color: 'text.secondary' }}>
                        {`${Math.round(props.value)}%`}
                    </Typography>
                </Box>
            </Box>
        );
    }

    return (
        <>
            <HeaderDashboard userActive={userActive} setOpenModalNotificacao={setOpenModalNotificacao} notificacoes={0} />
            <div style={{ marginTop: "60px", padding: "20px", minHeight: "100vh", marginBottom: "50px" }}>
                <div style={{ width: "100%", display: "flex", justifyContent: "center", marginTop: "20px", marginBottom: "20px" }}>
                    <div style={{ width: "80%" }}>
                        <Breadcrumbs aria-label="breadcrumb">
                            <Link
                                underline="hover"
                                sx={{ display: 'flex', alignItems: 'center', cursor: "pointer" }}
                                color="inherit"
                                onClick={() => navigate("../dashboard")}
                            >
                                <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                                Dashboard
                            </Link>
                            <Typography
                                sx={{ color: 'text.primary', display: 'flex', alignItems: 'center' }}
                            >
                                <ArticleIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                                Ficha Cadastral
                            </Typography>
                        </Breadcrumbs>
                    </div>
                </div>
                <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
                    <div style={{ width: window.innerWidth > 600 ? "80%" : "100%", backgroundColor: "#f9f9f9", padding: "30px", borderRadius: "8px" }}>
                        <div style={{ width: "100%" }}>
                            <h2 style={{ color: "black" }}>Registro Empresarial Abrangente</h2>
                            <p>Forneça os dados necessários da entidade de serviços profissionais para concluir seu processo de integração.</p>
                        </div>
                        <Box sx={{ width: '100%', marginTop: "20px", backgroundColor: "white", padding: "15px", borderRadius: "8px", boxShadow: "0 2px 4px rgba(0,0,0,0.1)" }}>
                            <h3>Progresso de preenchimento da ficha cadastral:</h3>
                            <div style={{ display: "flex", justifyContent: "flex-start", width: "fit-content", gap: "10px", marginBottom: "10px", marginTop: "10px", flexWrap: "wrap" }}>
                                <Chip
                                    label="Informações Pessoais"
                                    icon={sectionOneCompleted === 25 ? <CheckCircleOutlineIcon color="success" /> : <ErrorOutlineIcon color="error" />}
                                />
                                <Chip
                                    label="Contato e Endereço"
                                    icon={sectionTwoCompleted === 25 ? <CheckCircleOutlineIcon color="success" /> : <ErrorOutlineIcon color="error" />}
                                />
                                <Chip
                                    label="Status Conjugal"
                                    icon={sectionThreeCompleted === 25 ? <CheckCircleOutlineIcon color="success" /> : <ErrorOutlineIcon color="error" />}
                                />
                                <Chip
                                    label="Informações da Empresa"
                                    icon={sectionFourCompleted === 25 ? <CheckCircleOutlineIcon color="success" /> : <ErrorOutlineIcon color="error" />}
                                />
                            </div>

                            <LinearProgressWithLabel value={progress} />
                        </Box>

                        <div style={{ width: "100%", height: "fit-content", backgroundColor: "white", marginTop: "20px", paddingBottom: "20px", borderRadius: "8px", boxShadow: "0 2px 4px rgba(0,0,0,0.1)" }}>
                            <div style={{ display: "flex", alignItems: "center", padding: "15px", backgroundColor: "#1eff8733", borderTopLeftRadius: "8px", borderTopRightRadius: "8px" }}>
                                <PersonIcon style={{ fontSize: "35px", marginRight: "15px", color: "#1EFF86" }} />
                                <div>
                                    <h3 style={{ margin: 0, color: "black" }}>Informações Pessoais</h3>
                                </div>
                            </div>

                            <div style={{ marginTop: "30px", padding: "0 17px", display: "flex", justifyContent: "center", gap: "12px", flexWrap: "wrap" }}>
                                <TextField style={{ width: window.innerWidth > 600 ? "39%" : "100%" }} value={nome} onChange={e => setNome(e.target.value)} label="Nome completo" variant="outlined" size="small" placeholder="Informe seu nome completo" />
                                <TextField style={{ width: window.innerWidth > 600 ? "29%" : "100%" }} value={MascaraCpf(cpf)} onChange={e => setCpf(e.target.value)} label="CPF" variant="outlined" size="small" placeholder="Informe seu CPF" />
                                <TextField inputProps={{ maxLength: 8 }} style={{ width: window.innerWidth > 600 ? "29%" : "100%" }} value={FormatarData(dataNascimento) || dataNascimento} onChange={e => setDataNascimento(e.target.value)} label="Data de Nascimento" variant="outlined" size="small" placeholder="Informe sua data de nascimento" />
                            </div>
                            <div style={{ marginTop: "30px", padding: "0 17px", display: "flex", justifyContent: "center", gap: "12px", flexWrap: "wrap" }}>
                                <TextField inputProps={{ maxLength: 9 }} style={{ width: window.innerWidth > 600 ? "24%" : "100%" }} value={rg} onChange={e => setRg(e.target.value)} label="RG" variant="outlined" size="small" placeholder="Informe seu RG" />
                                <FormControl style={{ width: window.innerWidth > 600 ? "24%" : "100%" }} size="small">
                                    <InputLabel id="demo-simple-select-label">Órgão estadual de registro do RG</InputLabel>
                                    <Select
                                        value={orgaoEmissor}
                                        label="Órgão estadual de registro do RG"
                                        onChange={e => setOrgaoEmissor(e.target.value)}
                                    >
                                        {estadosBrasil.map((estado) => (
                                            <MenuItem key={estado} value={estado}>{estado}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                                {/* <TextField style={{ width: window.innerWidth > 600 ? "24%" : "100%" }} value={orgaoEmissor} onChange={e => setOrgaoEmissor(e.target.value)} label="Órgão estadual de registro do RG" variant="outlined" size="small" placeholder="Informe o órgão emissor do RG" /> */}
                                <TextField style={{ width: window.innerWidth > 600 ? "24%" : "100%" }} value={MascaraTituloEleitor(tituloEleitor)} onChange={e => setTituloEleitor(e.target.value)} label="Título de Eleitor" variant="outlined" size="small" placeholder="Informe seu título de eleitor" />
                                <TextField style={{ width: window.innerWidth > 600 ? "24%" : "100%" }} value={pisNisNit} onChange={e => setPisNisNit(e.target.value)} label="PIS / NIS / NIT" variant="outlined" size="small" placeholder="Informe seu PIS ou NIS ou NIT" />
                            </div>
                            <div style={{ marginTop: "30px", padding: "0 17px", display: "flex", justifyContent: "center", gap: "15px", flexWrap: "wrap" }}>
                                <TextField style={{ width: window.innerWidth > 600 ? "32%" : "100%" }} value={MascaraCnh(cnh)} onChange={e => setCnh(e.target.value)} label="CNH" variant="outlined" size="small" placeholder="Informe sua CNH" />
                                <FormControl style={{ width: window.innerWidth > 600 ? "32%" : "100%" }} size="small">
                                    <InputLabel id="demo-simple-select-label">Estado de emissão da CNH</InputLabel>
                                    <Select
                                        value={estadoEmissaoCnh}
                                        label="Estado de emissão da CNH"
                                        onChange={e => setEstadoEmissaoCnh(e.target.value)}
                                    >
                                        {estadosBrasil.map((estado) => (
                                            <MenuItem key={estado} value={estado}>{estado}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                                {/* <TextField style={{ width: window.innerWidth > 600 ? "32%" : "100%" }} value={estadoEmissaoCnh} onChange={e => setEstadoEmissaoCnh(e.target.value)} label="Estado de emissão da CNH" variant="outlined" size="small" placeholder="Informe o estado que foi emitada sua cnh" /> */}
                                <TextField style={{ width: window.innerWidth > 600 ? "32%" : "100%" }} value={naturalidade} onChange={e => setNaturalidade(e.target.value)} label="Naturalidade" variant="outlined" size="small" placeholder="Informe sua naturalidade" helperText="Ex: nome da cidade, UF" />
                            </div>
                        </div>
                        <div style={{ width: "100%", height: "fit-content", backgroundColor: "white", marginTop: "50px", paddingBottom: "20px", borderRadius: "8px", boxShadow: "0 2px 4px rgba(0,0,0,0.1)" }}>
                            <div style={{ display: "flex", alignItems: "center", padding: "15px", backgroundColor: "#1eff8733", borderTopLeftRadius: "8px", borderTopRightRadius: "8px" }}>
                                <ContactMailIcon style={{ fontSize: "35px", marginRight: "15px", color: "#1EFF86" }} />
                                <div>
                                    <h3 style={{ margin: 0, color: "black" }}>Contato e Endereço</h3>
                                </div>
                            </div>

                            <div style={{ marginTop: "30px", padding: "0 17px", display: "flex", justifyContent: "center", gap: "12px", flexWrap: "wrap" }}>
                                <TextField style={{ width: window.innerWidth > 600 ? "59%" : "100%" }} value={email} onChange={e => setEmail(e.target.value)} label="E-mail" variant="outlined" size="small" placeholder="Informe seu e-mail" />
                                <TextField style={{ width: window.innerWidth > 600 ? "38%" : "100%" }} value={MascaraTelefone(telefone)} onChange={e => setTelefone(e.target.value)} label="Telefone" variant="outlined" size="small" placeholder="Informe seu telefone" />
                            </div>
                            <div style={{ marginTop: "30px", padding: "0 17px", display: "flex", justifyContent: "center", gap: "12px", flexWrap: "wrap" }}>
                                <TextField style={{ width: window.innerWidth > 600 ? "20%" : "100%" }} value={MascaraCep(cep)} onChange={e => setCep(e.target.value)} label="CEP" variant="outlined" size="small" placeholder="Informe seu CEP" />
                                <TextField style={{ width: window.innerWidth > 600 ? "66%" : "100%" }} value={endereco} onChange={e => setEndereco(e.target.value)} label="Endereço" variant="outlined" size="small" placeholder="Informe seu endereço" />
                                <TextField style={{ width: window.innerWidth > 600 ? "10%" : "100%" }} value={numero} onChange={e => setNumero(e.target.value)} label="Número" variant="outlined" size="small" placeholder="Informe o número" />
                            </div>
                            <div style={{ marginTop: "30px", padding: "0 17px", display: "flex", justifyContent: "center", gap: "12px", flexWrap: "wrap" }}>
                                <TextField style={{ width: window.innerWidth > 600 ? "32%" : "100%" }} value={bairro} onChange={e => setBairro(e.target.value)} label="Bairro" variant="outlined" size="small" placeholder="Informe seu bairro" />
                                <TextField style={{ width: window.innerWidth > 600 ? "32%" : "100%" }} value={cidade} onChange={e => setCidade(e.target.value)} label="Cidade" variant="outlined" size="small" placeholder="Informe sua cidade" />
                                <TextField style={{ width: window.innerWidth > 600 ? "32%" : "100%" }} value={estado} onChange={e => setEstado(e.target.value)} label="Estado" variant="outlined" size="small" placeholder="Informe seu estado" />
                            </div>
                            <div style={{ marginTop: "30px", padding: "0 17px", display: "flex", justifyContent: "center", gap: "12px" }}>
                                <TextField style={{ width: "98%" }} value={complemento} onChange={e => setComplemento(e.target.value)} label="Complemento" variant="outlined" size="small" placeholder="Informe complemento" />
                            </div>
                        </div>

                        <div style={{ width: "100%", height: "fit-content", backgroundColor: "white", marginTop: "50px", paddingBottom: "20px", borderRadius: "8px", boxShadow: "0 2px 4px rgba(0,0,0,0.1)" }}>
                            <div style={{ display: "flex", alignItems: "center", padding: "15px", backgroundColor: "#1eff8733", borderTopLeftRadius: "8px", borderTopRightRadius: "8px" }}>
                                <VolunteerActivismIcon style={{ fontSize: "35px", marginRight: "15px", color: "#1EFF86" }} />
                                <div>
                                    <h3 style={{ margin: 0, color: "black" }}>Status Conjugal</h3>
                                </div>
                            </div>

                            <div style={{ marginTop: "30px", padding: "0 17px", display: "flex", justifyContent: "flex-start", gap: "12px", flexWrap: "wrap" }}>
                                <FormControl style={{ width: window.innerWidth > 600 ? "32%" : "100%" }} size="small">
                                    <InputLabel id="demo-simple-select-label">Estado civil</InputLabel>
                                    <Select
                                        value={estadoCivil}
                                        label="Estado civil"
                                        onChange={e => {
                                            if (e.target.value !== "Casado(a)") {
                                                setRegimeBens("");
                                                setCpfConjuge("");
                                            }
                                            setEstadoCivil(e.target.value)
                                        }}
                                    >
                                        <MenuItem value={"Solteiro(a)"}>Solteiro(a)</MenuItem>
                                        <MenuItem value={"Casado(a)"}>Casado(a)</MenuItem>
                                        <MenuItem value={"Divorciado(a)"}>Divorciado(a)</MenuItem>
                                        <MenuItem value={"Separado(a)"}>Separado(a)</MenuItem>
                                        <MenuItem value={"Viúvo(a)"}>Viúvo(a)</MenuItem>
                                    </Select>
                                </FormControl>

                                {estadoCivil === "Casado(a)" && (
                                    <>
                                        <FormControl style={{ width: window.innerWidth > 600 ? "32%" : "100%" }} size="small">
                                            <InputLabel id="demo-simple-select-label">Regime de bens</InputLabel>
                                            <Select
                                                value={regimeBens}
                                                label="Regime de bens"
                                                onChange={e => setRegimeBens(e.target.value)}
                                            >
                                                <MenuItem value={"Total"}>Total</MenuItem>
                                                <MenuItem value={"Parcial"}>Parcial</MenuItem>
                                                <MenuItem value={"Separação total"}>Separação total</MenuItem>
                                            </Select>
                                        </FormControl>
                                        <TextField style={{ width: window.innerWidth > 600 ? "32%" : "100%" }} value={MascaraCpf(cpfConjuge)} onChange={e => setCpfConjuge(e.target.value)} label="CPF do Conjuge" variant="outlined" size="small" />
                                    </>
                                )}
                            </div>
                        </div>

                        <div style={{ width: "100%", height: "fit-content", backgroundColor: "white", marginTop: "50px", paddingBottom: "20px", borderRadius: "8px", boxShadow: "0 2px 4px rgba(0,0,0,0.1)" }}>
                            <div style={{ display: "flex", alignItems: "center", padding: "15px", backgroundColor: "#1eff8733", borderTopLeftRadius: "8px", borderTopRightRadius: "8px" }}>
                                <ApartmentIcon style={{ fontSize: "35px", marginRight: "15px", color: "#1EFF86" }} />
                                <div>
                                    <h3 style={{ margin: 0, color: "black" }}>Informações da Empresa</h3>
                                </div>
                            </div>

                            <div style={{ marginTop: "30px", padding: "0 17px", display: "flex", justifyContent: "center", gap: "12px", flexWrap: "wrap" }}>
                                <TextField style={{ width: window.innerWidth > 600 ? "48%" : "100%" }} value={MascaraCnpj(cnpj)} onChange={e => setCnpj(e.target.value)} label="CNPJ" variant="outlined" size="small" placeholder="Informe o CNPJ" />
                                <TextField style={{ width: window.innerWidth > 600 ? "48%" : "100%" }} value={senhaGovBr} onChange={e => setSenhaGovBr(e.target.value)} label="Senha do Gov.br" variant="outlined" size="small" placeholder="Informe a senha do Gov.br" />
                            </div>
                            <div style={{ marginTop: "30px", padding: "0 17px", display: "flex", justifyContent: "center", gap: "12px" }}>
                                <TextField style={{ width: "97%" }} value={enderecoFiscal} onChange={e => setEnderecoFiscal(e.target.value)} label="Endereço fiscal" variant="outlined" size="small" placeholder="Informe o endereço fiscal caso tenha" helperText="Endereço fiscal é o endereço oficialmente registrado da empresa junto aos órgãos públicos (como Receita Federal, prefeitura e Secretaria da Fazenda). É nele que a empresa fica legalmente localizada para fins de cadastro, impostos e recebimento de notificações oficiais." />
                            </div>
                            <div style={{ marginTop: "30px", padding: "0 17px", display: "flex", justifyContent: "center", gap: "12px", flexWrap: "wrap" }}>
                                <TextField style={{ width: window.innerWidth > 600 ? "48%" : "100%" }} value={razaoSocial} onChange={e => setRazaoSocial(e.target.value)} label="Sugestão de nome para RAZÃO SOCIAL" variant="outlined" size="small" placeholder="Informe a sugestão de nome para RAZÃO SOCIAL" helperText="Razão social é o nome jurídico e oficial da empresa, aquele que aparece em contratos, notas fiscais, registros na Receita Federal, banco etc. É o nome “formal” da empresa." />
                                <TextField style={{ width: window.innerWidth > 600 ? "48%" : "100%" }} value={nomeFantasia} onChange={e => setNomeFantasia(e.target.value)} label="Sugestão de nome para NOME FANTASIA" variant="outlined" size="small" placeholder="Informe a sugestão de nome para NOME FANTASIA" helperText="Nome fantasia é o nome pelo qual a empresa é conhecida pelo público, usado em propaganda, fachada, redes sociais e marketing. Pode ser mais curto, criativo e fácil de lembrar." />
                            </div>
                        </div>
                        <div style={{ width: "100%", display: "flex", justifyContent: "flex-end" }}>
                            <Button variant="contained" onClick={handleSaveFichaCadastral} style={{ marginTop: "30px", backgroundColor: "#1EFF86", color: "black", width: window.innerWidth > 600 ? "fit-content" : "100%" }}>Salvar Informações</Button>
                        </div>

                    </div>
                </div>
            </div>
            <Loading open={open} />
            <AlertSuccess openSnackbarSuccess={openSnackbarSuccess} setOpenSnackbarSuccess={setOpenSnackbarSuccess} mensagem={mensagem} />

        </>
    );
}

export default FichaCadastral;